const serviceRegion$2 = 'eastus'; // 区域
const subscriptionKey = '626e5ad6ab1449d6a60b0caca519da6d'; // 密钥
let checkTimer = null;
import $ from 'jquery'
/**
 * @description 语音转文字
 */
class SpeechRecognizer {
  constructor() {
    this._recognizer = null;
    this._isOpenRecognize = true;
  }

  _setIsOpenRecognize(bool) {
    this._isOpenRecognize = bool;
  }

  /**
   * @description 识别语音
   * @param audioFile
   * @param languageValue
   * @param {undefined | object} options
   * @param {function} options.onProgress
   * @returns {Promise<void>}
   */
  async recognize(audioFile, languageValue, options) {
    try {
      this._setIsOpenRecognize(true);
      const { token, onProgress = () => { } } = options;
      const SpeechSDK = window.SpeechSDK;
      if (!SpeechSDK) {
        throw new Error('No SpeechSDK');
      }
      if (this._isOpenRecognize === false) {
        throw new Error('Is Recognizing');
      }

      await new Promise((resolve, reject) => {
        // 使用密钥
        // const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(this._subscriptionKey, this._serviceRegion);
        // 使用token
        const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, serviceRegion$2);
        // 使用fromEndpoint
        // const speechConfig = SpeechSDK.SpeechConfig.fromEndpoint({href: 'wss://smartvideomaker.cognitiveservices.azure.com/stt/speech/recognition/conversation/cognitiveservices/v1'}, '');
        // // 设置Token
        // speechConfig.setProperty('SpeechServiceAuthorization_Token', token)

        // Gets speech recognition output format (simple or detailed). Note: This output format is for speech recognition result, use [SpeechConfig.speechSynthesisOutputFormat] to get synthesized audio output format. Gets/Sets speech recognition output format (simple or detailed). Note: This output format is for speech recognition result, use [SpeechConfig.speechSynthesisOutputFormat] to set synthesized audio output format.
        // 获取语音识别输出格式（简单或详细）。注：此输出格式用于语音识别结果，请使用[SpeechConfig.speechSynthesisOutputFormat]获取合成音频输出格式。获取/设置语音识别输出格式（简单或详细）。注：此输出格式用于语音识别结果，请使用[SpeechConfig.speechSynthesisOutputFormat]设置合成音频输出格式。
        speechConfig.outputFormat = SpeechSDK.OutputFormat.Detailed;

        // 识别语句后，即可获取已识别语音的偏移量和持续时间。 使用 Recognized 事件，还可以获取每个单词的偏移量和持续时间。 若要请求每个单词的偏移量和持续时间，首先必须设置相应的 SpeechConfig 属性
        speechConfig.requestWordLevelTimestamps();

        // 语音识别的常见任务是指定输入（或源）语言。
        speechConfig.speechRecognitionLanguage = languageValue;

        const audioConfig = SpeechSDK.AudioConfig.fromWavFileInput(audioFile);

        this._recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

        // 可以设置进度
        this._recognizer.recognizing = function (s, e) {
          switch (e.result.reason) {
            case SpeechSDK.ResultReason.RecognizingSpeech: {
              onProgress({
                code: 200,
                type: 'recognizing',
                data: e.result,
                message: 'speech recognizing',
              });
              // console.log('RecognizingSpeech::');
              break;
            }
            case SpeechSDK.ResultReason.NoMatch: {
              onProgress({
                code: 200,
                type: 'recognizing failed',
                message: 'Speech could not be recognizing',
              });
              // console.log(`RecognizingSpeech:::NOMATCH: Speech could not be recognizing`);
              break;
            }
            default:
              onProgress({
                code: 200,
                type: 'recognizing failed',
                message: 'something error in  recognizing',
              });
          }
        };

        this._recognizer.recognized = function (s, e) {
          switch (e.result.reason) {
            case SpeechSDK.ResultReason.RecognizedSpeech: {
              onProgress({
                code: 200,
                type: 'recognized',
                data: e.result,
                message: 'speech recognized',
              });
              // console.log('RecognizedSpeech:::', e.result.text);
              break;
            }
            case SpeechSDK.ResultReason.NoMatch: {
              onProgress({
                code: 200,
                type: 'recognized failed',
                message: 'Speech could not be recognized',
              });
              // console.log(`RecognizedSpeech:::NOMATCH: Speech could not be recognized`);
              break;
            }
            default:
              onProgress({
                code: 200,
                type: 'recognized failed',
                message: 'something error in recognized',
              });
          }
        };

        this._recognizer.canceled = (s, e) => {
          // Indicates that the end of the audio stream was reached.
          // 表示已到达音频流的末尾。
          if (e.reason === SpeechSDK.CancellationReason.EndOfStream) {
            // 语音转文字完成
            resolve({
              code: 200,
              type: 'recognizer end',
              message: 'Indicates that the end of the audio stream was reached',
            });
          }

          // Indicates that an error occurred during speech recognition.
          // 指示在语音识别期间发生错误。
          if (e.reason === SpeechSDK.CancellationReason.Error) {
            reject(e);
            // console.log(`"CANCELED: ErrorCode=${e.errorCode}`);
            // console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`);
            // console.log("CANCELED: Did you set the speech resource key and region values?");
          }
        };

        this._recognizer.sessionStopped = (s, e) => {
          reject(e);
        };

        this._recognizer.startContinuousRecognitionAsync();
      });
    } catch (e) {
      throw e;
    } finally {
      this.stopRecognition();
    }
  }

  /**
   * @description 退出识别
   */
  stopRecognition() {
    this._setIsOpenRecognize(false);
    if (this._recognizer) {
      this._recognizer.stopContinuousRecognitionAsync();
      this._recognizer = null;
    }
  }

  /**
   * @description 获取token
   * @returns {Promise<unknown>}
   * @private
   */
  static async getAuthorizationToken(url = 'https://eastus.api.cognitive.microsoft.com/sts/v1.0/issuetoken') {
    // 默认url
    if (url === 'https://eastus.api.cognitive.microsoft.com/sts/v1.0/issuetoken') {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
          'Content-type': 'application/x-www-form-urlencoded',
        },
      });
      const token = await res.text();
      return token;
    } else {
      // 自己的接口url
      const res = await fetch(url, {
        method: 'GET',
      });
      const { code, data } = await res.json();
      if (code !== 200) {
        throw new Error(code.toString());
      }
      return data.token;
    }
  }
}

const serviceRegion$1 = 'eastus'; // 区域

/**
 * @description 文字转语音
 */
class SpeechSynthesizer {
  constructor() {
    this._synthesizer = null;
    this._isOpenSynthesizer = true; // 是否开启合成
  }

  _setIsOpenSynthesizer(bool) {
    this._isOpenSynthesizer = bool;
  }

  _getSSML = (options) => {
    const { textValue, languageValue = 'en-US', voiceValue = 'en-US-JennyNeural', voiceStyleValue = 'general', roleValue = '', secondaryValue = '', voiceSpeed = 0, pitch = 0 } = options;

    let ssmlHeader = '<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="{LANGUAGE}">{0}</speak>',
      ssmlVoiceName = '<voice name="{VOICE}">{0}</voice>',
      ssmlProperties = '<prosody rate="{SPEED}" pitch="{PITCH}">{TEXT}</prosody>',
      ssmlExpression = '<mstts:express-as {STYLE_ATTRIBUTE} {ROLE_PLAY_ATTRIBUTE}>{0}</mstts:express-as>',
      ssmlSecondaryLocale = '<lang xml:lang="{SECONDARY_LOCALE}">{0}</lang>',

      ssmlText = ssmlProperties,
      escapedText;
    ssmlText = ssmlText.replace('{SPEED}', voiceSpeed + '%');
    ssmlText = ssmlText.replace('{PITCH}', pitch + '%');

    ssmlText = ssmlExpression.replace('{0}', ssmlText);

    ssmlHeader = ssmlHeader.replace('{LANGUAGE}', languageValue);

    if (voiceStyleValue) {
      ssmlText = ssmlText.replace('{STYLE_ATTRIBUTE}', 'style="' + voiceStyleValue + '"');
    } else {
      ssmlText = ssmlText.replace('{STYLE_ATTRIBUTE}', '');
    }

    if (roleValue) {
      ssmlText = ssmlText.replace('{ROLE_PLAY_ATTRIBUTE}', 'role="' + roleValue + '"');
    } else {
      ssmlText = ssmlText.replace('{ROLE_PLAY_ATTRIBUTE}', '');
    }

    ssmlText = ssmlVoiceName.replace('{0}', ssmlText);
    ssmlText = ssmlText.replace('{VOICE}', voiceValue);

    escapedText = textValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');


    if (secondaryValue) {
      escapedText = ssmlSecondaryLocale.replace('{0}', escapedText);
      escapedText = escapedText.replace('{SECONDARY_LOCALE}', secondaryValue);
    }
    ssmlText = ssmlHeader.replace('{0}', ssmlText);
    ssmlText = ssmlText.replace('{TEXT}', escapedText);

    return ssmlText
  }

  _clearSynthesizer() {
    if (this._synthesizer) {
      this._synthesizer.close();
      this._synthesizer = null;
    }
  }

  /**
   * @description 退出合成
   */
  stopSynthesizer() {
    this._setIsOpenSynthesizer(false);
    this._clearSynthesizer();
  }

  /**
   * @description 合成音频
   * @param text
   * @param options
   * @returns {Promise<void>}
   */
  async synthesizer(text, options) {
    try {
      this._setIsOpenSynthesizer(true);
      const { token } = options;

      const SpeechSDK = window.SpeechSDK;
      if (!SpeechSDK) {
        throw new Error('No SpeechSDK');
      }
      if (this._isOpenSynthesizer === false) {
        throw new Error('Is Synthesizer');
      }

      let result;
      await new Promise((resolve, reject) => {

        // 使用密钥
        // const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(this._subscriptionKey, this._serviceRegion);
        // 使用token
        const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, serviceRegion$1);

        // due to a bug in Chromium (https://bugs.chromium.org/p/chromium/issues/detail?id=1028206)
        // mp3 playback has some beeps, using a higher bitrate here as a workaround.
        // Audio16Khz32KBitRateMonoMp3 Audio24Khz96KBitRateMonoMp3 Audio24Khz48KBitRateMonoMp3
        speechConfig.speechSynthesisOutputFormat = SpeechSDK.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3;

        this._synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, null);

        // 指示已完成语音合成。
        this._synthesizer.synthesisCompleted = (s, e) => {
          // console.log('synthesisCompleted::', s, e)
          result = e.result.audioData;
          resolve({
            code: 200,
            data: result,
            message: '指示已完成语音合成。',
          });
          this._clearSynthesizer();
        };

        // 指示已取消语音合成。
        this._synthesizer.SynthesisCanceled = (s, e) => {
          // console.log('SynthesisCanceled::', s, e)
          reject(e);
          this._clearSynthesizer();
        };

        // 指示语音合成已开始。
        this._synthesizer.synthesisStarted = (s, e) => {
          // console.log("synthesisStarted::::::", s, e);
        };

        // 	指示语音合成正在进行。 每次 SDK 从语音服务收到音频区块，都会触发此事件。
        this._synthesizer.synthesizing = (s, e) => {
          // console.log("synthesizing:::::", s, e);
        };

        this._synthesizer.speakSsmlAsync(
          this._getSSML({ ...options, textValue: text }),
          () => { },
          error => {
            console.log(error);
            this._clearSynthesizer();
          });
      });

      return result;
    } catch (e) {
      throw e;
    } finally {
      this.stopSynthesizer();
    }
  }

  // todo 这些方法放到fj-package的fj-speech-recognition中，再由其打包过来
  /**
   * @desc 创建批量合成任务
   * @param {Arrayr} textArr
   * @param  options
   * @returns
   */
  async createBatchSynthesis(textArr, options) {
    const { token, taskId } = options;
    const url = `https://${serviceRegion$2}.customvoice.api.speech.microsoft.com/api/texttospeech/3.1-preview1/batchsynthesis`;
    const ssmlList = textArr.map(text => ({ "text": this._getSSML({ ...options, textValue: text }), "name": text.slice(0, 5) }));
    const info = {
      displayName: 'batch synthesis sample',
      description: 'my ssml test',
      textType: 'SSML',
      inputs: ssmlList,
      properties: {
        "outputFormat": "audio-24khz-48kbitrate-mono-mp3",
        "wordBoundaryEnabled": false,
        "sentenceBoundaryEnabled": false,
        "concatenateResult": false, // 如果 properties.concatenateResult 属性设置为 true，则每个合成结果将写入同一音频输出文件
        "decompressOutputFiles": false,
        // "destinationContainerUrl":true

      }
    };
    let id = ''
    // todo token 的方式可以调用吗？要保护subscriptionKey不被泄露
    await $.ajax(url, {
      type: 'POST',
      data: JSON.stringify(info),
      headers: {
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        "Content-type": "application/json",
        // 'Authorization': 'Bearer ' + token,
      },
      success: (data) => {
        id = data.id
        // this.getBatchSynthesis(data.id)
      },
      error: (e) => {
        console.log('error', e)
      },
    });
    return id
  }
  /**
   * @desc 获取批量合成任务结果
   * @param {*} id
   * @param {*} successCallback
   * @param {*} errorCallback
   */
  getBatchSynthesis(id, successCallback, errorCallback) {
    const url = `https://${serviceRegion$2}.customvoice.api.speech.microsoft.com/api/texttospeech/3.1-preview1/batchsynthesis/${id}`;
    $.ajax(url, {
      type: 'GET',
      headers: {
        'Ocp-Apim-Subscription-Key': subscriptionKey,
        // 'Authorization': 'Bearer ' + token.current,
      },
      success: (e) => {
        if (e.status === "Succeeded") {
          successCallback(e);
          this.deleteBatchSynthesis(id)
        } else {
          // todo 是否需要一个最大的时长限制，比如10分钟以内没有成功的当失败处理
          checkTimer = setTimeout(() => {
            this.getBatchSynthesis(id, successCallback, errorCallback);
            clearTimeout(checkTimer)
          }, 1000)
        }
      },
      error: (e) => {
        console.log('error', e)
        errorCallback()
      }
    })
  }
  /**
   * @desc 删除批量合成任务
   * @param {*} id
   */
  deleteBatchSynthesis(id) {
    const url = `https://${serviceRegion$2}.customvoice.api.speech.microsoft.com/api/texttospeech/3.1-preview1/batchsynthesis/${id}`;
    $.ajax(url, {
      type: 'DELETE',
      headers: {
        'Ocp-Apim-Subscription-Key': subscriptionKey,
      },
      success: (e) => {},
      error: (e) => {}
    })
  }
}

const serviceRegion = 'eastus'; // 区域

/**
 * @description 文字转语音
 */
class SpeechRealTimePreview {
  constructor() {
    this._isOpenSynthesizer = true; // 是否开启合成
    this._player = null;
    this._playerSynthesizer = null;
  }

  _setIsOpenSynthesizer(bool) {
    this._isOpenSynthesizer = bool;
  }

  _getSSML = (options) => {
    const { textValue, languageValue = 'en-US', voiceValue = 'en-US-JennyNeural', voiceStyleValue = 'general', roleValue = '', secondaryValue = '', voiceSpeed = 0, pitch = 0 } = options;

    let ssmlHeader = '<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="{LANGUAGE}">{0}</speak>',
      ssmlVoiceName = '<voice name="{VOICE}">{0}</voice>',
      ssmlProperties = '<prosody rate="{SPEED}" pitch="{PITCH}">{TEXT}</prosody>',
      ssmlExpression = '<mstts:express-as {STYLE_ATTRIBUTE} {ROLE_PLAY_ATTRIBUTE}>{0}</mstts:express-as>',
      ssmlSecondaryLocale = '<lang xml:lang="{SECONDARY_LOCALE}">{0}</lang>',

      ssmlText = ssmlProperties,
      escapedText;
    ssmlText = ssmlText.replace('{SPEED}', voiceSpeed + '%');
    ssmlText = ssmlText.replace('{PITCH}', pitch + '%');

    ssmlText = ssmlExpression.replace('{0}', ssmlText);

    ssmlHeader = ssmlHeader.replace('{LANGUAGE}', languageValue);

    if (voiceStyleValue) {
      ssmlText = ssmlText.replace('{STYLE_ATTRIBUTE}', 'style="' + voiceStyleValue + '"');
    } else {
      ssmlText = ssmlText.replace('{STYLE_ATTRIBUTE}', '');
    }

    if (roleValue) {
      ssmlText = ssmlText.replace('{ROLE_PLAY_ATTRIBUTE}', 'role="' + roleValue + '"');
    } else {
      ssmlText = ssmlText.replace('{ROLE_PLAY_ATTRIBUTE}', '');
    }

    ssmlText = ssmlVoiceName.replace('{0}', ssmlText);
    ssmlText = ssmlText.replace('{VOICE}', voiceValue);

    escapedText = textValue.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');


    if (secondaryValue) {
      escapedText = ssmlSecondaryLocale.replace('{0}', escapedText);
      escapedText = escapedText.replace('{SECONDARY_LOCALE}', secondaryValue);
    }
    ssmlText = ssmlHeader.replace('{0}', ssmlText);
    ssmlText = ssmlText.replace('{TEXT}', escapedText);

    return ssmlText
  }

  async realTimePreview(text, options) {
    try {
      this._setIsOpenSynthesizer(true);
      const { token, onAudioEndCallback, onAudioStartCallback } = options;

      const SpeechSDK = window.SpeechSDK;
      if (!SpeechSDK) {
        throw new Error('No SpeechSDK');
      }
      if (this._isOpenSynthesizer === false) {
        throw new Error('Is Synthesizer');
      }

      let result;
      await new Promise((resolve, reject) => {
        const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, serviceRegion);

        this._player = new SpeechSDK.SpeakerAudioDestination();
        this._player.onAudioEnd = function () {
          onAudioEndCallback();
        };
        this._player.onAudioStart = function () {
          onAudioStartCallback();
        };

        const audioConfig = SpeechSDK.AudioConfig.fromSpeakerOutput(this._player);

        this._playerSynthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig);

        // 指示已完成语音合成。
        this._playerSynthesizer.synthesisCompleted = (s, e) => {
          // console.log('synthesisCompleted::', s, e)
          result = e.result.audioData;
          this._clearPlayerSynthesizer();
          resolve({
            code: 200,
            data: result,
            message: '指示已完成语音合成。',
          });
        };

        // 指示已取消语音合成。
        this._playerSynthesizer.SynthesisCanceled = (s, e) => {
          // console.log('SynthesisCanceled::', s, e)
          this._clearPlayerSynthesizer();
          reject(e);
        };

        this._playerSynthesizer.speakSsmlAsync(
          this._getSSML({ ...options, textValue: text }),
          () => { },
          error => {
            console.log(error);
            this._clearPlayerSynthesizer();
          });
      });
      return result;
    } catch (e) {
      throw e;
    } finally {
      this.stopPlayerSynthesizer();
    }
  }

  stopRealTimePreview() {
    if (this._player) {
      this._player.pause();
    }

    this._player = null;
  }

  _clearPlayerSynthesizer() {
    if (this._playerSynthesizer) {
      this._playerSynthesizer.close();
      this._playerSynthesizer = null;
    }
  }

  /**
   * @description 退出合成
   */
  stopPlayerSynthesizer() {
    this._setIsOpenSynthesizer(false);
    this._clearPlayerSynthesizer();
  }
}

export { SpeechRealTimePreview as FJSpeechRealTimePreview, SpeechRecognizer as FJSpeechRecognition, SpeechSynthesizer as FJSpeechSynthesizer };
